export default __webpack_public_path__ + "static/media/EN_14.ce315388.svg";